<div class="cm-side">
  <div class="cm-head">
    <div class="cm-seg" role="tablist" aria-label="Panel">
      <button type="button" role="tab" [class.on]="pane === 'details'" [attr.aria-selected]="pane === 'details'"
        (click)="selectTab('details')">Details</button>
      <button type="button" role="tab" *ngIf="showThreadsTab" [class.on]="pane !== 'details'" [attr.aria-selected]="pane !== 'details'"
        (click)="selectTab('threads')">Threads<span class="cm-count" *ngIf="threads.length"> {{ threads.length }}</span></button>
    </div>
    <button type="button" class="cm-x" (click)="close.emit()" aria-label="Close panel"><mat-icon>close</mat-icon></button>
  </div>

  <div class="cm-pane" *ngIf="pane === 'details'">
    <dl class="cm-kv">
      <div><dt>Space name</dt><dd>{{ channel?.channelName }}</dd></div>
      <div *ngIf="channel?.teamName"><dt>Space group</dt><dd>{{ channel.teamName }}</dd></div>
      <div><dt>Created by</dt><dd class="cap">{{ channel?.createdByName }}<ng-container *ngIf="channel?.createdOn">, {{ channel.createdOn | date: 'MMM d, y' }}</ng-container></dd></div>
    </dl>

    <h2>Members ({{ memberTotal }})</h2>
    <div class="cm-msearch" *ngIf="channel?.channelVisibility === 'private'">
      <i class="fa fa-search" aria-hidden="true"></i>
      <label for="cm-member-search" class="cm-sr">Search for a member</label>
      <input id="cm-member-search" type="text" placeholder="Search for a member" [ngModel]="search"
        (ngModelChange)="searchChange.emit($event)" (keyup.enter)="searchSubmit.emit()" />
    </div>

    <ng-container *ngIf="split as s">
      <ng-container *ngIf="onlineIds">
        <div class="cm-mgrp">Online · {{ s.online.length }}</div>
        <ng-container *ngFor="let user of s.online; trackBy: trackUser">
          <ng-container *ngTemplateOutlet="member; context: { $implicit: user, on: true }"></ng-container>
        </ng-container>
        <div class="cm-mgrp">Offline · {{ s.offline.length }}</div>
      </ng-container>
      <ng-container *ngFor="let user of (showAllOffline ? s.offline : s.offline.slice(0, OFFLINE_PREVIEW)); trackBy: trackUser">
        <ng-container *ngTemplateOutlet="member; context: { $implicit: user, on: false }"></ng-container>
      </ng-container>
      <button type="button" class="cm-more" *ngIf="s.offline.length > OFFLINE_PREVIEW" (click)="showAllOffline = !showAllOffline"
        [attr.aria-expanded]="showAllOffline">
        {{ showAllOffline ? 'Show less' : '+ ' + (s.offline.length - OFFLINE_PREVIEW) + ' more ' + (s.offline.length - OFFLINE_PREVIEW === 1 ? 'member' : 'members') }}
      </button>
    </ng-container>
  </div>

  <div class="cm-pane cm-list" *ngIf="pane === 'list'">
    <button type="button" class="cm-trow" *ngFor="let t of threads; trackBy: trackThread" (click)="openThread.emit(t.message)">
      <span class="cm-av">
        <img *ngIf="t.message?._sender?.profileUrl; else tini" [src]="t.message._sender.profileUrl" alt="" />
        <ng-template #tini>{{ starterInitials(t.message) }}</ng-template>
      </span>
      <span class="cm-tbody">
        <span class="cm-tname cap">{{ t.message?._sender?.nickname }}</span>
        <span class="cm-tprev">{{ preview(t.message) }}</span>
        <span class="cm-tmeta">{{ t.replies }} {{ t.replies === 1 ? 'reply' : 'replies' }}<ng-container *ngIf="t.lastBy"> · last by <span class="cap">{{ t.lastBy }}</span></ng-container><ng-container *ngIf="t.lastTime"> · {{ t.lastTime }}</ng-container></span>
      </span>
    </button>
  </div>

  <div class="cm-pane cm-thread" *ngIf="pane === 'thread'">
    <button type="button" class="cm-back" *ngIf="threads.length" (click)="selectTab('threads')">
      <mat-icon>arrow_back</mat-icon> All threads
    </button>
    <ng-content></ng-content>
  </div>
</div>

<ng-template #member let-user let-on="on">
  <div class="cm-mem" [class.off]="onlineIds && !on">
    <span class="cm-av" [class.on]="on">
      <img *ngIf="user.profileUrl; else ini" [src]="user.profileUrl" alt="" />
      <ng-template #ini>{{ user.shortName || '?' }}</ng-template>
    </span>
    <span class="cm-mname">
      <span class="cap">{{ user.nickname || 'Member' }}</span>
      <small *ngIf="user.createdOn">Added {{ user.createdOn | date: 'd MMM y' }}</small>
    </span>
    <em *ngIf="user.userType === 'partner'">Admin</em>
  </div>
</ng-template>
